module.exports = __webpack_public_path__ + "static/media/attention_gray_transparent.eb51fc08.svg";